<template>
  <div class="container my-5">
    <h2 class="mb-4 text-primary">Institute Payment</h2>

    <!-- Responsive row for filters -->
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <label for="teacher">Select Teacher:</label>
        <select v-model="selectedTeacher" class="form-control" id="teacher">
          <option value="">-- All Teachers --</option>
          <option v-for="teacher in teachers" :key="teacher.id" :value="teacher.id">
            {{ teacher.user.first_name }}
          </option>
        </select>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label for="dateFilter" class="font-weight-bold">Filter by Date:</label>
        <select v-model="selectedDateFilter" class="form-control" id="dateFilter">
          <option value="all">All</option>
          <option value="today">Today</option>
          <option value="last_week">Last Week</option>
          <option value="last_month">Last Month</option>
        </select>
      </div>
    </div>

    <!-- Total payment -->
    <div class="alert alert-success text-right mb-4">
      <strong>Total Payment For Institute:</strong> {{ totalInstitutePayment.toFixed(2) }}
    </div>

    

<!-- Loader Spinner -->
<div v-if="loading" class="d-flex justify-content-center align-items-center my-5">
  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<!-- Table of payments -->
<div v-else>
  <div v-if="teacherPayments.length > 0" class="table-responsive mt-3">
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Teacher Name</th>
          <th>Total Payment</th>
          <th>Price Rate</th>
          <th>Institute Payment</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="payment in teacherPayments" :key="payment.teacher_id">
          <td>{{ payment.teacher_name }}</td>
          <td>{{ payment.total_payment }}</td>
          <td>{{ payment.price_rate }}</td>
          <td>{{ payment.institute_payment }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <nav v-if="totalPages > 1" class="mt-4">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Previous</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: currentPage === page }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">Next</button>
        </li>
      </ul>
    </nav>
  </div>

  <div v-else class="text-center text-danger mt-3">
    No payments available for this filter.
  </div>
</div>


  </div>
</template>

  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        teachers: [],
        selectedTeacher: '',
        teacherPayments: [],
        selectedDateFilter: 'all',
        loading: false,
        totalInstitutePayment: 0,
        currentPage: 1,
        perPage: 1, // Increased perPage for better pagination
        totalPages: 0,
      };
    },
    mounted() {
      this.fetchTeachers();
      this.fetchTeacherPayments(); // Initial load
    },
    watch: {
      selectedTeacher() {
        this.fetchTeacherPayments();
      },
      selectedDateFilter() {
        this.fetchTeacherPayments();
      }
    },
    methods: {
      fetchTeachers() {
        const instituteId = localStorage.getItem('institute_id');
  
        axios.get('/get-teachers-by-institute', {
          params: { institute_id: instituteId }
        })
        .then(response => {
          this.teachers = response.data;
        })
        .catch(error => {
          console.error('Error fetching teachers:', error);
        });
      },
  
      fetchTeacherPayments() {
        this.loading = true;
        const instituteId = localStorage.getItem('institute_id');
  
        axios.get('/get-institute-payments', {
          params: {
            institute_id: instituteId,
            teacher_id: this.selectedTeacher,
            date_filter: this.selectedDateFilter,
            page: this.currentPage,
            per_page: this.perPage
          }
        })
        .then(response => {
          this.teacherPayments = response.data.data;
          this.totalInstitutePayment = response.data.total_institute_payment;
          this.totalPages = Math.ceil(response.data.total / this.perPage);
        })
        .catch(error => {
          console.error('Error fetching institute payments:', error);
        })
        .finally(() => {
          this.loading = false;
        });
      },
  
      changePage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.fetchTeacherPayments();
        }
      }
    },
  };
  </script>
  
<style scoped>
.container {
  max-width: 1200px;
  padding: 0 15px;
  height: 100dvh;
}

.table-responsive {
  overflow-x: auto;
}

.table th,
.table td {
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

.page-link {
  color: #3498DB;
  cursor: pointer;
}

.page-link:hover {
  color: #2980B9;
}

.alert {
  font-size: 1.1rem;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

@media (max-width: 769px) {
  .container {
  max-width: 300px;
  padding: 0 0px;
}

  h2 {
    font-size: 1.5rem;
    text-align: center;
  }

  .text-right {
    text-align: center !important;
  }

  .alert {
    font-size: 1rem;
    text-align: center;
  }

  .pagination {
    flex-wrap: wrap;
  }

  .pagination .page-item {
    margin: 2px;
  }

  select.form-control,
  label {
    font-size: 0.9rem;
  }

  .table {
    font-size: 0.85rem;
  }

  .row > div {
    padding-left: 5px;
    padding-right: 5px;
  }

  .table th,
  .table td {
    padding: 0.4rem;
  }
}
</style>

  